import { render, staticRenderFns } from "./Songs.vue?vue&type=template&id=6fd1f6c7&"
import script from "./Songs.vue?vue&type=script&lang=js&"
export * from "./Songs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports